import {
  FINANCIAL_REPORTS_SUCCESS,
  FINANCIAL_REPORTS_COMPLETE_SUCCESS,
  FINANCIAL_REPORTS_FAILED,
  CALCULATION_REPORTS_SUCCESS,
  TARGET_REPORTS_SUCCESS,
  RATIO_KEY_FIGURES_REPORTS_SUCCESS,
  INCENTIVE_RATIO_TREND_REPORTS_SUCCESS,
  OUTGOING_CLAIMS_REPORT_SUCCESS,
  TOP_N_ATTRIBUTES_REPORTS_SUCCESS,
  DUPLICATE_PAYMENT_REPORTS_SUCCESS,
  ANAMOLY_REPORTS_SUCCESS,
  APPROVAL_POSTING_HISTORY_REPORTS_SUCCESS,
  CONTRACT_HISTORY_APPROVAL_SUCCESS,
  DOCUMENT_HISTORY_APPROVAL_SUCCESS,
  NTE_LIFE_TIME_SUCCESS,
  CONTRACT_SEARCH_BY_CUSTOMER,
  SIMULATE_REBATE_ESTIMATOR,
  CLEAR_SIMULATE_REBATE_ESTIMATOR,
  SAVE_SIMULATE_REBATE_ESTIMATOR_STATE,
  CLEAR_SIMULATE_REBATE_ESTIMATOR_STATE,
  EXCEPTION_SEARCH_BY_CUSTOMER,
  SAVE_SIMULATION_STATE,
  CLEAR_SIMULATION_STATE,
  CLEAR_EXCEPTION_SEARCH_BY_CUSTOMER,
  FORMULA_EXCEPTION,
  CLEAR_FORMULA_EXCEPTION,
  CALCULATION_FORMULA_VALUES_REPORTS_SUCCESS,
  GET_DATAGRID_METADATA_SUCCESS,
  CONTRACT_CHANGE_REPORTS_SUCCESS,
  CALCULATION_REPORTS_COMPLETE_SUCCESS,
  CALCULATION_REPORTS_FAILED,
  GET_REPORT_LIST_DATA_SUCCESS,
  INVOICE_REPORTS_SUCCESS,
  INVOICE_REPORTS_COMPLETE_SUCCESS,
  INVOICE_REPORTS_FAILED,
  CONTRACT_REPORTS_SUCCESS,
  CONTRACT_REPORTS_COMPLETE_SUCCESS,
  CONTRACT_REPORTS_FAILED,
  FETCH_START,
  FETCH_END,
  EXCEPTION_FETCH_START,
  EXCEPTION_FETCH_END,
  CLEAR_EXECUTE_REPORT,
  CONTRACT_REPORTS_OVERLAP_SUCCESS,
  DYNAMIC_QUERY_FIELDS_SUCCESS,
  DYNAMIC_QUERY_FIELDS_SUCCESS_NEW,
  QUERY_LIST_SUCCESS,
  QUERY_LIST_CLEAR,
  QUERY_LIST_ADMIN_SUCCESS,
  QUERY_RESULTS_FINAL_SUCCESS,
  ALERT_MANAGEMENT_REPORT_SUCCESS,
  DYNAMIC_FILTER_API_SUCCESS,
  DYNAMIC_QUERY_DETAILS_SUCCESS,
  CLAIMS_FORMAT_FIELDS_SUCCESS,
  INCOMING_CLAIM_DETAILS_SUCCESS,
  CALCULATION_SIMULATION_FIELDS_SUCCESS,
  QUERY_TYPES_SUCCESS,
  LOAD_TARGET_DATA,
  COLL_PORTAL_CUST_SUPP,
  OUTGOING_CLAIMS_FORMAT_FIELDS_SUCCESS,
  OUTGOING_CLAIM_DETAILS_SUCCESS,
  GET_ALL_ORG_USERS,
  TABLE_DETERMINATION_SUCCESS,
  PREDEFINED_QUERY_RESULTS_FINAL_SUCCESS,
  PREDEFINED_QUERY_DETAILS_SUCCESS,
  CUSTOM_VIEW,
  GET_FILTER_VALUES_SUCCESS,
  BATCH_JOB_FILTERS,
  DYNAMIC_QUERY_FILTER,
  DYNAMIC_QUERY_FILTER_BY_ID,
  RECONCILE_INTEGRATION_SUCCESS,
  FILTER_VALUES_BY_ID,
  CLEAR_FILTER,
  ADD_MATERIAL_DESIGN,
  EXECUTE_FILTER_VALUES_SUCCESS,
  GET_FILTER_CONFIGURATIONS,
  GET_FILTER_CONFIGURATIONS_BY_PAGE,
  VIEW_MATERIAL_DESIGN_SUCCESS,
  CLEAR_MATERIAL_DESIGN_VIEW,
  GET_MATERIAL_BY_PROFILE_SUCCESS,
  GET_EMPLOYEE_BY_PROFILE_SUCCESS,
  GET_FILTER_CONFIGURATION_BY_ID_SUCCESS,
  GET_COLLABORATION_BY_ID_SUCCESS,
  MEMBERSHIP_TABLE_SUCCESS,
  GET_CONTROL_CONFIG_SUCCESS,
  CONTROL_CONFIG_DATA_SUCCESS,
  SUPPLIER_REBATE_ACCRUAL_POSTING_RESULTS_SUCCESS,
  EXECUTE_REPORT_SUCCESS,
  POSTINGS_RESULTS_SUCCESS
} from '../../../actions/Simulations/OperationalReports/ActionTypes';

const initialState = {
  financialReportsData: [],
  calculationReportsData: [],
  reportListData: [],
  invoiceReportsData: [],
  contractReportsData: [],
  contractReportsOverlapData: [],
  queryListSuccessData: [],
  queryListAdminSuccessData: [],
  queryResultsFinalData: [],
  alertManagementReportData: [],
  dynamicFilterApiData: [],
  dynamicQueryDetailsData: [],
  claimsFormatFieldsData: [],
  calculationSimulationData: [],
  targetData: [],
  contractChangeReportsData: [],
  error: false,
  loading: false,
  exceptionLoading: false,
  collaborationCustSuppData: {},
  orgUsers: [],
  tableDetermination: [],
  prefinedQueryDetailsData: [],
  predefinedResultsFinalData: [],
  predefinedListSuccessData: [],
  ratioKeyFiguresRepotsData: [],
  incentiveRatioTrendRepotsData: [],
  calculationFormulaValues: [],
  topNattributesReportsData: [],
  duplicatePaymentReportsData: [],
  approvalPostingHistoryReportsData: [],
  contractHistoryApprovedData: [],
  documentHistoryApprovedData: [],
  nteLifeTimeData: [],
  contractSearchByCustomer: [],
  exceptionSearchByCustomer: [],
  simulateRebateEstimator: [],
  formulaException: [],
  dataGridMetadataResult: {},
  anamolyReportsData: [],
  dynamicQueryFilters: [],
  dynamicQueryFilterData: {},
  filterValuesByIdData: {},
  materialDesignViewData: null,
  customViewFilters: [],
  globalFilterViewFilters: [],
  batchjobCreationFilters: {},
  savedPayload: null,
  savedData: null,
  savedRebateEstimatorPayload: null,
  savedRebateEstimatorData: null,
  membershipTableData: [],
  filterConfigurationsByPage: [],
  controlConfigData: {},
  controlConfigReadData: [],
  supplierRebateAccrualPostingDataResults: [],
  executionQueryReport: []
};

const OperationalReportsReducer = (state = initialState, action) => {
  switch (action.type) {
    // Financial Reports
    case FINANCIAL_REPORTS_SUCCESS:
      return {
        ...state,
        financialReportsData: action.data,
      };
    case FINANCIAL_REPORTS_COMPLETE_SUCCESS:
      return {
        ...state,
        financialReportsCompleteData: action.data,
      };
    case FINANCIAL_REPORTS_FAILED:
      return {
        ...state,
        error: true,
      };
    // Calculation Reports
    case CALCULATION_REPORTS_SUCCESS:
      return {
        ...state,
        calculationReportsData: action.data,
      };
    case CALCULATION_REPORTS_FAILED:
      return {
        ...state,
        error: true,
      };
    case CALCULATION_REPORTS_COMPLETE_SUCCESS:
      return {
        ...state,
        calculationReportsCompleteData: action.data,
      };
    case GET_REPORT_LIST_DATA_SUCCESS:
      return {
        ...state,
        reportListData: action.data,
      };

    // Target reports
    case TARGET_REPORTS_SUCCESS:
      return {
        ...state,
        targetReportsData: action.data,
      };
    case RATIO_KEY_FIGURES_REPORTS_SUCCESS:
      return {
        ...state,
        ratioKeyFiguresRepotsData: action.data,
      };
    case INCENTIVE_RATIO_TREND_REPORTS_SUCCESS:
      return {
        ...state,
        incentiveRatioTrendRepotsData: action.data,
      };
    case OUTGOING_CLAIMS_REPORT_SUCCESS:
      return {
        ...state,
        outgoingClaimsReportData: action.data,
      };
    case TOP_N_ATTRIBUTES_REPORTS_SUCCESS:
      return {
        ...state,
        topNattributesReportsData: action.data,
      };
    case DUPLICATE_PAYMENT_REPORTS_SUCCESS:
      return {
        ...state,
        duplicatePaymentReportsData: action.data,
      };
    case ANAMOLY_REPORTS_SUCCESS:
      return {
        ...state,
        anamolyReportsData: action.data,
      };
    case APPROVAL_POSTING_HISTORY_REPORTS_SUCCESS:
      return {
        ...state,
        approvalPostingHistoryReportsData: action.data,
      };
    case CONTRACT_HISTORY_APPROVAL_SUCCESS:
      return {
        ...state,
        contractHistoryApprovedData: action.data,
      };
    case DOCUMENT_HISTORY_APPROVAL_SUCCESS:
      return {
        ...state,
        documentHistoryApprovedData: action.data,
      };
    case NTE_LIFE_TIME_SUCCESS:
      return {
        ...state,
        nteLifeTimeData: action.data,
      };
    case CONTRACT_SEARCH_BY_CUSTOMER:
      return {
        ...state,
        contractSearchByCustomer: action.data,
      };
    case SIMULATE_REBATE_ESTIMATOR:
      return {
        ...state,
        simulateRebateEstimator: action.data,
      };
    case CLEAR_SIMULATE_REBATE_ESTIMATOR:
      return {
        ...state,
        simulateRebateEstimator: [],
      };
    case SAVE_SIMULATE_REBATE_ESTIMATOR_STATE:
      return {
        ...state,
        savedRebateEstimatorPayload: action.payload.payload,
        savedRebateEstimatorData: action.payload.data
      };
    case CLEAR_SIMULATE_REBATE_ESTIMATOR_STATE:
      return {
        ...state,
        savedRebateEstimatorPayload: null,
        savedRebateEstimatorData: null
      };
    case EXCEPTION_SEARCH_BY_CUSTOMER:
      return {
        ...state,
        exceptionSearchByCustomer: action.data,
      };
    case CLEAR_EXCEPTION_SEARCH_BY_CUSTOMER:
      return {
        ...state,
        exceptionSearchByCustomer: [],
      };
    case SAVE_SIMULATION_STATE:
      return {
        ...state,
        savedPayload: action.payload.payload,
        savedData: action.payload.data
      };
    case CLEAR_SIMULATION_STATE:
      return {
        ...state,
        savedPayload: null,
        savedData: null
      };
    case FORMULA_EXCEPTION:
      return {
        ...state,
        formulaException: action.data,
      };
    case CLEAR_FORMULA_EXCEPTION:
      return {
        ...state,
        formulaException: [],
      };
    case EXCEPTION_FETCH_START:
      return {
        ...state,
        exceptionLoading: true,
      };
    case EXCEPTION_FETCH_END:
      return {
        ...state,
        exceptionLoading: false,
      }
    case GET_DATAGRID_METADATA_SUCCESS:
      return {
        ...state,
        dataGridMetadataResult: action.data,
      };
    case CALCULATION_FORMULA_VALUES_REPORTS_SUCCESS:
      return {
        ...state,
        calculationFormulaValues: action.data,
      };
    // Contract Change
    case CONTRACT_CHANGE_REPORTS_SUCCESS:
      return {
        ...state,
        contractChangeReportsData: action.data,
      };
    // Invoice reports
    case INVOICE_REPORTS_SUCCESS:
      return {
        ...state,
        invoiceReportsData: action.data,
      };
    case INVOICE_REPORTS_COMPLETE_SUCCESS:
      return {
        ...state,
        invoiceReportsCompleteData: action.data,
      };
    case INVOICE_REPORTS_FAILED:
      return {
        ...state,
        error: true,
      };
    //contract reports
    case CONTRACT_REPORTS_SUCCESS:
      return {
        ...state,
        contractReportsData: action.data,
      };
    case CONTRACT_REPORTS_COMPLETE_SUCCESS:
      return {
        ...state,
        contractReportsCompleteData: action.data,
      };
    case CONTRACT_REPORTS_FAILED:
      return {
        ...state,
        error: true,
      };
    case FETCH_START:
      return {
        ...state,
        loading: true,
      };
    case FETCH_END:
      return {
        ...state,
        loading: false,
      };
    case CONTRACT_REPORTS_OVERLAP_SUCCESS:
      return {
        ...state,
        contractReportsOverlapData: action.data,
      };
    case DYNAMIC_QUERY_FIELDS_SUCCESS:
      return {
        ...state,
        dynamicQueryFieldsData: action.data,
      };
    case EXECUTE_FILTER_VALUES_SUCCESS:
      return {
        ...state,
        executeFilterData: action.data,
      };
    case DYNAMIC_QUERY_FIELDS_SUCCESS_NEW:
      return {
        ...state,
        dynamicQueryFieldsDataNew: action.data,
      };
    case QUERY_LIST_SUCCESS:
      return {
        ...state,
        queryListSuccessData: action.data,
      };
    case QUERY_LIST_CLEAR:
      return {
        ...state,
        queryListSuccessData: [],
      };
    case QUERY_LIST_ADMIN_SUCCESS:
      return {
        ...state,
        queryListAdminSuccessData: action.data,
      };
    case QUERY_RESULTS_FINAL_SUCCESS:
      return {
        ...state,
        queryResultsFinalData: action.data,
      };
    case ALERT_MANAGEMENT_REPORT_SUCCESS:
      return {
        ...state,
        alertManagementReportData: action.data,
      };
    case DYNAMIC_FILTER_API_SUCCESS:
      return {
        ...state,
        dynamicFilterApiData: action.data,
      };
    case DYNAMIC_QUERY_DETAILS_SUCCESS:
      return {
        ...state,
        dynamicQueryDetailsData: action.data,
      };
    case CLAIMS_FORMAT_FIELDS_SUCCESS:
      return {
        ...state,
        claimsFormatFieldsData: action.data,
      };
    case INCOMING_CLAIM_DETAILS_SUCCESS:
      return {
        ...state,
        incomingClaimDetailsData: action.data,
      };
    case CALCULATION_SIMULATION_FIELDS_SUCCESS:
      return {
        ...state,
        calculationSimulationData: action.data,
      };
    case QUERY_TYPES_SUCCESS:
      return {
        ...state,
        queryTypesSuccess: action.data,
      };
    case LOAD_TARGET_DATA:
      return {
        ...state,
        targetData: action.data,
      };
    case COLL_PORTAL_CUST_SUPP:
      return {
        ...state,
        collaborationCustSuppData: action.data,
      };
    case OUTGOING_CLAIMS_FORMAT_FIELDS_SUCCESS:
      return {
        ...state,
        outgoingClaimsFormatFieldsData: action.data,
      };
    case OUTGOING_CLAIM_DETAILS_SUCCESS:
      return {
        ...state,
        outgoingClaimDetailsData: action.data,
      };
    case GET_ALL_ORG_USERS:
      return {
        ...state,
        orgUsers: action.data,
      };
    case TABLE_DETERMINATION_SUCCESS:
      return {
        ...state,
        tableDetermination: action.data,
      };
    case PREDEFINED_QUERY_RESULTS_FINAL_SUCCESS:
      return {
        ...state,
        predefinedResultsFinalData: action.data,
      };
    case PREDEFINED_QUERY_DETAILS_SUCCESS:
      return {
        ...state,
        predefinedListSuccessData: action.data,
      };
    case CUSTOM_VIEW:
      return {
        ...state,
        customViewFilters: action.data,
      };
    case GET_FILTER_VALUES_SUCCESS:
      return {
        ...state,
        globalFilterViewFilters: action.data,
      };
    case BATCH_JOB_FILTERS: //used for batchjob creation
      return {
        ...state,
        batchjobCreationFilters: action.data,
      };
    case DYNAMIC_QUERY_FILTER:
      return {
        ...state,
        dynamicQueryFilters: action.data,
      };
    case DYNAMIC_QUERY_FILTER_BY_ID:
      return {
        ...state,
        dynamicQueryFilterData: action.data,
      };
    case FILTER_VALUES_BY_ID:
      return {
        ...state,
        filterValuesByIdData: action.data,
      };
    case CLEAR_FILTER:
      return {
        ...state,
        dynamicQueryFilters: null,
        dynamicQueryFilterData: null,
      };
    case GET_FILTER_CONFIGURATIONS:
      return {
        ...state,
        filterConfigurationsAllData: action.data,
      };
    case GET_FILTER_CONFIGURATIONS_BY_PAGE:
      return {
        ...state,
        filterConfigurationsByPage: action.data,
      };
    case VIEW_MATERIAL_DESIGN_SUCCESS:
      // console.log(
      //   'VIEW_MATERIAL_DESIGN_SUCCESS reducer called with data:',
      //   action.data,
      // );
      return {
        ...state,
        materialDesignViewData: action.data,
      };

    case CLEAR_MATERIAL_DESIGN_VIEW:
      return {
        ...state,
        materialDesignViewData: null,
      };
    case GET_MATERIAL_BY_PROFILE_SUCCESS:
      return {
        ...state,
        materialByProfileData: action.data,
      };
    case GET_EMPLOYEE_BY_PROFILE_SUCCESS:
      return {
        ...state,
        employeeByProfileData: action.data,
      };
    case GET_FILTER_CONFIGURATION_BY_ID_SUCCESS:
      return {
        ...state,
        filterConfigurationByIdData: action.data,
      };
    case GET_COLLABORATION_BY_ID_SUCCESS:
      return {
        ...state,
        collaborationByIdData: action.data,
      };
    case MEMBERSHIP_TABLE_SUCCESS:
      return {
        ...state,
        membershipTableData: action.data,
      };
    case GET_CONTROL_CONFIG_SUCCESS:
      return {
        ...state,
        controlConfigData: action.data,
      };
    case CONTROL_CONFIG_DATA_SUCCESS:
      return {
        ...state,
        controlConfigReadData: action.data,
      };
    case SUPPLIER_REBATE_ACCRUAL_POSTING_RESULTS_SUCCESS:
      return {
        ...state,
        supplierRebateAccrualPostingDataResults: action.data,
      };
    case POSTINGS_RESULTS_SUCCESS:
      return {
        ...state,
        postingsResults: action.data,
      };
    case EXECUTE_REPORT_SUCCESS:
      return {
        ...state,
        executionQueryReport: action.data
      }
    case CLEAR_EXECUTE_REPORT:
      return {
        ...state,
        executionQueryReport: []
      }
    default:
      return state;
  }
};

export default OperationalReportsReducer;
